"use strict";

const NOW_YEAR = new Date().getFullYear();
const today_ = new Date();
const firstDayOfMonth_ = moment(
  new Date(today_.getFullYear(), today_.getMonth(), 1),
).toDate();
const FIRST_DAY = moment(firstDayOfMonth_).format("YYYY-MM-DD");
const TODAY = moment(today_).format("YYYY-MM-DD");
const stationName = $("#station-name").val();
const stationLatitude = parseFloat($("#station-latitude").val());
const stationLongitude = parseFloat($("#station-longitude").val());
const LAST_DATE = moment($("#last-date").val()).format("YYYY-MM-DD");
$("#filterDate").val(LAST_DATE);

let dataTable;
let map;

function syncFilterDateFromPeriode() {
  const mode = $("#waktu").val();
  const picked = $("#periode").datepicker("getDate");
  if (!picked) {
    return;
  }
  if (mode === "month") {
    $("#filterDate").val(moment(picked).format("YYYY"));
  } else if (mode === "day") {
    $("#filterDate").val(moment(picked).format("YYYY-MM"));
  } else {
    $("#filterDate").val(moment(picked).format("YYYY-MM-DD"));
  }
}

function formatNumber(input) {
  // Periksa apakah input adalah angka yang valid (bukan null, undefined, atau NaN)
  if (typeof input !== "number" || isNaN(input)) {
    // Kembalikan string '0,00' agar konsisten dengan format output
    return "0,00";
  }

  // Opsi ini akan selalu memformat angka dengan tepat 2 digit desimal
  const options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  };

  // Format angka menggunakan locale 'de-DE'
  // (menggunakan titik sebagai pemisah ribuan dan koma sebagai pemisah desimal)
  return input.toLocaleString("de-DE", options);
}

$(document).ready(function () {
  // Configuration
  const MAX_POINTS = 50;
  const wsUrl = "wss://ws.higertech.com/connection/websocket";

  // Sparkline Options
  const sparklineOptions = (color, unit) => ({
    type: "line",
    data: {
      labels: [],
      datasets: [
        {
          data: [],
          borderColor: color,
          backgroundColor: color + "20",
          borderWidth: 2,
          pointRadius: 0,
          pointBackgroundColor: color,
          pointBorderColor: "#fff",
          pointBorderWidth: 2,
          fill: true,
          tension: 0.4,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          enabled: true,
          intersect: false,
          mode: "index",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          titleColor: "#1e293b",
          bodyColor: "#1e293b",
          borderColor: color,
          borderWidth: 1,
          padding: 10,
          displayColors: false,
          callbacks: {
            title: function (items) {
              return items[0].label;
            },
            label: function (item) {
              return formatIndonesianNumber(item.parsed.y, 3) + " " + unit;
            },
          },
        },
      },
      scales: {
        x: { display: false },
        y: { display: false, beginAtZero: false, grace: "10%" },
      },
      animation: false,
    },
  });

  // Initialize Charts (Higertech / B001 only — elements hidden for other brands)
  let velocityChart = null;
  let flowChart = null;

  const velocityCanvas = document.getElementById("velocity-sparkline");
  if (velocityCanvas) {
    velocityChart = new Chart(
      velocityCanvas.getContext("2d"),
      sparklineOptions("#20c997", "m/s"),
    );
  }

  const flowCanvas = document.getElementById("flow-sparkline");
  if (flowCanvas) {
    flowChart = new Chart(
      flowCanvas.getContext("2d"),
      sparklineOptions("#0d6efd", "m3/s"),
    );
  }

  // Centrifuge Connection
  const centrifuge = new Centrifuge(wsUrl);

  // Track date for auto-reset baselines
  let currentSessionDay = moment().format("YYYY-MM-DD");
  let currentSessionMonth = moment().format("YYYY-MM");

  centrifuge.on("connected", function (context) {
    // console.log("Centrifuge connected", context);
  });

  centrifuge.on("disconnected", function (context) {
    console.log("Centrifuge disconnected", context);
  });

  const sub = centrifuge.newSubscription("device:realtime");

  sub.on("publication", function (ctx) {
    const data = ctx.data;
    if (data && data.device_id === deviceId) {
      updateRealtimeUI(data);
    }
  });

  sub.subscribe();
  centrifuge.connect();

  function updateRealtimeUI(data) {
    moment.locale("id");
    const now = moment();
    const timestamp = now.format("D MMMM YYYY HH:mm:ss");
    const todayString = now.format("YYYY-MM-DD");
    const monthString = now.format("YYYY-MM");

    // Auto-reset baselines when date changes
    if (data.flow_total !== undefined && data.flow_total !== null) {
      // Reset Hari Ini
      if (todayString !== currentSessionDay) {
        $("#first-today-flow-total").val(data.flow_total);
        currentSessionDay = todayString;
      }
      // Reset Bulan Ini
      if (monthString !== currentSessionMonth) {
        $("#first-month-flow-total").val(data.flow_total);
        currentSessionMonth = monthString;
      }
    }

    // Update Cumulative Timer
    const timerSpan = $("#cumulative-timer");
    if (timerSpan.length) {
      const parts = timerSpan.text().split(" - ");
      if (parts.length > 0) {
        timerSpan.text(parts[0] + " - " + timestamp);
      }
    }

    // Values
    if (data.velocity !== undefined && data.velocity !== null) {
      const el = $("#realtime-velocity");
      if (el.length) {
        el.text(formatIndonesianNumber(data.velocity, 3)).addClass(
          "updated-value",
        );
        setTimeout(() => el.removeClass("updated-value"), 800);
      }
      if (velocityChart) {
        updateChart(velocityChart, data.velocity, timestamp);
      }
    }

    if (data.flow !== undefined && data.flow !== null) {
      const el = $("#realtime-flow");
      if (el.length) {
        el.text(formatIndonesianNumber(data.flow, 3)).addClass("updated-value");
        setTimeout(() => el.removeClass("updated-value"), 800);
      }
      if (flowChart) {
        updateChart(flowChart, data.flow, timestamp);
      }
    }

    if (data.flow_total !== undefined && data.flow_total !== null) {
      const el = $("#realtime-total");
      el.text(formatIndonesianNumber(data.flow_total, 2)).addClass(
        "updated-value",
      );
      setTimeout(() => el.removeClass("updated-value"), 800);

      // Update Daily Volume: flow_total - firstTodayFlowTotal
      const firstToday = parseFloat($("#first-today-flow-total").val());
      console.log("flow_total", data.flow_total);
      console.log("firstToday", firstToday);
      if (!isNaN(firstToday)) {
        const volDaily = data.flow_total - firstToday;
        const elVolDaily = $("#realtime-volume-daily");
        elVolDaily
          .text(formatIndonesianNumber(volDaily, 3))
          .addClass("updated-value");
        setTimeout(() => elVolDaily.removeClass("updated-value"), 800);

        console.log("volDaily", volDaily);
      }

      // Update Monthly Volume: flow_total - firstMonthFlowTotal
      const firstMonth = parseFloat($("#first-month-flow-total").val());
      if (!isNaN(firstMonth)) {
        const volMonthly = data.flow_total - firstMonth;
        const elVolMonthly = $("#realtime-volume-monthly");
        elVolMonthly
          .text(formatIndonesianNumber(volMonthly, 3))
          .addClass("updated-value");
        setTimeout(() => elVolMonthly.removeClass("updated-value"), 800);
      }
    }

    if (data.battery !== undefined && data.battery !== null) {
      const capacity = getBatteryCapacity(data.battery);
      const batteryText = `${capacity}% (${formatIndonesianNumber(data.battery, 2)} V)`;
      $("#battery-status-text").text(batteryText);

      // Update Battery Badge & Icon
      const battBadge = $("#battery-badge");
      const battIcon = battBadge.find(".mdi");

      battBadge.removeClass("badge-success badge-warning badge-danger");
      battIcon.removeClass("mdi-battery-10 mdi-battery-50 mdi-battery-80");

      if (capacity <= 20) {
        battBadge.addClass("badge-danger");
        battIcon.addClass("mdi-battery-10");
      } else if (capacity <= 50) {
        battBadge.addClass("badge-warning");
        battIcon.addClass("mdi-battery-50");
      } else {
        battBadge.addClass("badge-success");
        battIcon.addClass("mdi-battery-80");
      }
    }

    // Signal Update
    if (data.signal !== undefined && data.signal !== null) {
      const signalPercent = data.signal;
      $("#signal-status-text").text(signalPercent + "%");

      const signalBadge = $("#signal-badge");
      const signalIcon = $("#signal-icon");

      signalBadge.removeClass("badge-success badge-warning badge-danger");
      signalIcon.removeClass(
        "mdi-signal-cellular-1 mdi-signal-cellular-2 mdi-signal-cellular-3",
      );

      if (signalPercent <= 20) {
        signalBadge.addClass("badge-danger");
        signalIcon.addClass("mdi-signal-cellular-1");
      } else if (signalPercent <= 50) {
        signalBadge.addClass("badge-warning");
        signalIcon.addClass("mdi-signal-cellular-2");
      } else {
        signalBadge.addClass("badge-success");
        signalIcon.addClass("mdi-signal-cellular-3");
      }
    }
  }

  function updateChart(chart, newValue, timestamp) {
    const data = chart.data.datasets[0].data;
    const labels = chart.data.labels;

    data.push(newValue);
    labels.push(timestamp);

    if (data.length > MAX_POINTS) {
      data.shift();
      labels.shift();
    }

    chart.update("none");

    // Update Pulse Position
    const meta = chart.getDatasetMeta(0);
    const lastPoint = meta.data[meta.data.length - 1];
    if (lastPoint) {
      const pulseId = chart.canvas.id.replace("-sparkline", "-pulse");
      $(`#${pulseId}`)
        .css({
          left: lastPoint.x + "px",
          top: lastPoint.y + "px",
        })
        .show();
    }
  }

  map = new google.maps.Map(document.getElementById("map"), {
    center: { lat: stationLatitude, lng: stationLongitude },
    zoom: 10,
    mapId: "4504f8b37365c3d0",
    streetViewControl: false,
  });

  new google.maps.Marker({
    position: { lat: stationLatitude, lng: stationLongitude }, // Gunakan koordinat yang sama dengan center
    map: map,
    title: stationName,
  });

  (function ($) {
    $.fn.datepicker.dates["id"] = {
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
      daysShort: ["Mgu", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
      daysMin: ["Mg", "Sn", "Sl", "Ra", "Ka", "Ju", "Sa"],
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ],
      monthsShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ags",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ],
      today: "Hari Ini",
      clear: "Kosongkan",
      format: "dd/mm/yyyy",
      titleFormat: "MM yyyy",
      weekStart: 0,
    };
  })(jQuery);

  // Inisialisasi pertama kali (default: pilih Tanggal / Jam-Jaman)
  let datePicker = $("#periode")
    .datepicker({
      format: "dd MM yyyy", // Default: Pilih Tanggal
      autoclose: true,
      todayHighlight: true,
      language: "id", // Bahasa Indonesia
      orientation: "bottom",
    })
    .datepicker("setDate", new Date(LAST_DATE)); // Set default ke hari ini

  // Event untuk mengubah value input saat tanggal dipilih (picker atau chevron)
  $("#periode").on("changeDate", function (e) {
    const selectedDate = e.format("yyyy-mm-dd");
    $(this).attr("data-value", selectedDate);
    syncFilterDateFromPeriode();
    reloadTelemetryForMode($("#waktu").val());
    updatePeriodNavStateOrg064();
  });

  // Keterangan faktor kalibrasi (tampil di web saja; di-strip saat export)
  function formatCalibrationFactor(value) {
    const parsed = parseFloat(value);
    if (isNaN(parsed)) {
      return null;
    }
    return parsed.toLocaleString("de-DE", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 4,
    });
  }

  function calibrationNoteHtml(row) {
    if (!row || row.calibration === null || row.calibration === undefined) {
      return "";
    }
    const factor = formatCalibrationFactor(row.calibration);
    if (factor === null) {
      return "";
    }
    return `<br><small class="text-muted"> Menggunakan Faktor Kalibrasi ${factor}</small>`;
  }

  function isCalibrationRow(row) {
    return !!row && row.calibration !== null && row.calibration !== undefined;
  }

  // Bersihkan HTML / keterangan kalibrasi sebelum export (Excel/PDF)
  function cleanExportCell(data, node) {
    let text = "";
    if (node) {
      text = $(node).text();
    } else if (data !== null && data !== undefined) {
      text = $("<div>").html(String(data)).text();
    }
    return text
      .replace(/\s*Menggunakan Faktor Kalibrasi\s*[\d.,]+/gi, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  // Cegah excelHtml5 salah parse format ID (mis. "610,57" → 61057).
  // Suffix \x01 mematahkan regex angka, lalu di-strip saat tulis cell string.
  function forceExcelText(value) {
    if (value === null || value === undefined || value === "") {
      return value;
    }
    return String(value) + "\x01";
  }

  function initializeDataTable(columns, headerHtml) {
    if ($.fn.DataTable.isDataTable("#table-telemetri")) {
      dataTable.clear().destroy();
      $("#table-telemetri thead").empty();
      $("#table-telemetri tbody").empty();
    }

    // Tambahkan header baru dengan rowspan & colspan
    $("#table-telemetri thead").append(headerHtml);

    // Inisialisasi DataTable baru
    dataTable = $("#table-telemetri").DataTable({
      dom: "Brti",
      paging: false,
      ordering: false,
      processing: true,
      serverSide: true,
      createdRow: function (tr, data) {
        if (isCalibrationRow(data)) {
          $(tr).addClass("bg-soft-warning");
        }
      },
      ajax: {
        url: "/Station/DataTableDetailOrg064",
        type: "POST",
        data: {
          deviceId: deviceId,
          stationId: $("#station-id").val(),
          stationType: $("#station-type").val(),
          filterDate: $("#filterDate").val(),
          selectedTime: $("#waktu").val(),
        },
        dataSrc: function (json) {
          return json.data;
        },
      },
      columns: columns,
      buttons: [
        {
          extend: "collection",
          text: "Download",
          className: "btn btn-primary btn-sm dropdown-toggle",
          buttons: [
            {
              extend: "excelHtml5",
              text: "Download Excel",
              className: "dropdown-item",
              title: "Data Telemetri",
              exportOptions: {
                format: {
                  body: function (data, row, column, node) {
                    return forceExcelText(cleanExportCell(data, node));
                  },
                },
              },
            },
            {
              extend: "pdfHtml5",
              text: "Download PDF",
              className: "dropdown-item",
              title: "Data Telemetri",
              orientation: "landscape",
              pageSize: "A4",
              exportOptions: {
                format: {
                  body: function (data, row, column, node) {
                    return cleanExportCell(data, node);
                  },
                },
              },
              customize: function (doc) {
                doc.content[1].table.widths = Array(
                  doc.content[1].table.body[0].length + 1,
                )
                  .join("*")
                  .split("");
              },
            },
          ],
        },
      ],
    });
  }

  // **Header & Kolom untuk Mode Hour**
  let headerHour = `
        <tr>
            <th rowspan="2">Tanggal</th>
            <th rowspan="2">Jam (WIB)</th>
            <th colspan="2">Volume Pemakaian</th>
            <th rowspan="2">Volume Total (m³)</th>
            <th colspan="2">Baterai Logger</th>
        </tr>
        <tr>
            <th>m³/jam</th>
            <th>lt/jam</th>
            <th>Tegangan (V)</th>
            <th>Kapasitas (%)</th>
        </tr>`;

  let columnsHour = [
    {
      title: "Tanggal",
      data: "readingDate",
    },
    {
      title: "Jam (WIB)",
      data: "readingHourRange",
    },
    {
      title: "m³/jam",
      data: "flowRate",
      defaultContent: "-",
      render: function (data, type, row, meta) {
        if (data == 0) return 0;
        if (data > 0) return formatNumber(data);
      },
    },
    {
      title: "lt/jam",
      data: "flowRate",
      defaultContent: "-",
      render: function (data, type, row, meta) {
        if (data == 0) return 0;
        const liter = data * 1000;
        if (data > 0) return formatNumber(liter);
      },
    },
    // {
    //   title: "m³/bulan",
    //   data: "flowMonth",
    //   defaultContent: "-",
    //   render: function (data, type, row, meta) {
    //     if (data == 0) return 0;
    //     if (data > 0) return formatNumber(parseFloat(data));
    //   },
    // },
    // {
    //   title: "lt/bulan",
    //   data: "flowMonth",
    //   defaultContent: "-",
    //   render: function (data, type, row, meta) {
    //     if (data > 0) return formatNumber(parseFloat(data) * 1000);
    //   },
    // },
    {
      title: "Volume Total (m³)",
      data: null,
      render: function (data, type, row, meta) {
        let nextRow =
          meta.row + 1 < meta.settings.aoData.length
            ? meta.settings.aoData[meta.row + 1]._aData
            : null;

        const totalText =
          nextRow && typeof nextRow.flowTotal === "number"
            ? formatNumber(nextRow.flowTotal)
            : formatNumber(row.flowTotal);

        return totalText + calibrationNoteHtml(row);
      },
    },
    {
      title: "Tegangan (V)",
      data: "batteryVolt",
      render: function (data, type, row, meta) {
        return data ? parseFloat(data).toFixed(2) : "-";
      },
    },
    {
      title: "Kapasitas (%)",
      data: "batteryCapacity",
      defaultContent: "-",
      render: function (data, type, row, meta) {
        return data ? parseFloat(data).toFixed(0) : "-";
      },
    },
  ];

  // **Header & Kolom untuk Mode Day**
  let headerDay = `
        <tr>
            <th rowspan="2">Tanggal</th>
            <th colspan="2">Voleme Harian</th>
            <th rowspan="2">Voleme Total (m³)</th>
        </tr>
        <tr>
            <th>m³/jam</th>
            <th>lt/jam</th>
        </tr>`;

  let columnsDay = [
    {
      title: "Tanggal",
      data: "readingDate",
      render: (data) =>
        moment.parseZone(data).locale("id").format("D MMM YYYY"),
    },
    {
      title: "m³/hari",
      data: "flowRate",
      defaultContent: "-",
      render: function (data, type, row, meta) {
        if (data == 0) return 0;
        if (data > 0) return formatNumber(parseFloat(data));
      },
    },
    {
      title: "lt/hari",
      data: "flowRate",
      defaultContent: "-",
      render: function (data, type, row, meta) {
        if (data == 0) return 0;
        if (data > 0) return formatNumber(parseFloat(data) * 1000);
      },
    },
    // {
    //   title: "m³/bulan",
    //   data: "flowMonth",
    //   defaultContent: "-",
    //   render: function (data, type, row, meta) {
    //     if (data == 0) return 0;
    //     if (data > 0) return formatNumber(parseFloat(data));
    //   },
    // },
    // {
    //   title: "lt/bulan",
    //   data: "flowMonth",
    //   defaultContent: "-",
    //   render: function (data, type, row, meta) {
    //     console.log("data:", data);
    //     console.log(data);
    //     if (data > 0) return formatNumber(parseFloat(data) * 1000);
    //   },
    // },
    {
      title: "Volume Total (m³)",
      data: "flowTotal",
      render: function (data, type, row, meta) {
        return formatNumber(data) + calibrationNoteHtml(row);
      },
    },
  ];

  // **Header & Kolom untuk Mode Month**
  let headerMonth = `
        <tr>
            <th rowspan="2">Bulan</th>
            <th colspan="2">Volume Bulanan</th>
            <th rowspan="2">Volume Total (m³)</th>
        </tr>
        <tr>
            <th>m³/bulan</th>
            <th>lt/bulan</th>
        </tr>`;

  let columnsMonth = [
    {
      title: "Bulan",
      data: "readingMonth",
      render: (data) => moment.parseZone(data).locale("id").format("MMMM YYYY"),
    },
    {
      title: "m³/bulan",
      data: "flowMonth",
      defaultContent: "-",
      render: function (data, type, row, meta) {
        const value = parseFloat(data);
        const formattedValue = formatNumber(value);
        if (data == 0) return 0;
        if (data > 0) return formattedValue;
      },
    },
    {
      title: "lt/bulan",
      data: "flowMonth",
      defaultContent: "-",
      render: function (data, type, row, meta) {
        const value = parseFloat(data) * 1000;
        const formattedValue = formatNumber(value);
        if (data == 0) return 0;
        if (data > 0) return formattedValue;
      },
    },
    {
      title: "Volume Debit (m³)",
      data: "flowTotal",
      render: function (data, type, row, meta) {
        const note = calibrationNoteHtml(row);
        if (data == 0) return "0" + note;
        if (data > 0) return formatNumber(parseFloat(data)) + note;
        return note || undefined;
      },
    },
  ];

  function getPeriodeModeOrg064() {
    return $("#waktu").val() || "hour";
  }

  function getCurrentPeriodeMomentOrg064() {
    const picked = $("#periode").datepicker("getDate");
    return picked ? moment(picked) : moment();
  }

  function isAtCurrentBoundaryOrg064(m, mode) {
    const now = moment();
    if (mode === "month") {
      return m.year() >= now.year();
    }
    if (mode === "day") {
      return m
        .clone()
        .startOf("month")
        .isSameOrAfter(now.clone().startOf("month"));
    }
    return m.clone().startOf("day").isSameOrAfter(now.clone().startOf("day"));
  }

  function updatePeriodNavStateOrg064() {
    const mode = getPeriodeModeOrg064();
    const atMax = isAtCurrentBoundaryOrg064(
      getCurrentPeriodeMomentOrg064(),
      mode,
    );
    const $next = $("#periode-next");
    if (!$next.length) {
      return;
    }
    $next.prop("disabled", atMax);
    $next.attr("aria-disabled", atMax ? "true" : "false");
    $next.toggleClass("disabled", atMax);
  }

  function reloadTelemetryForMode(mode) {
    switch (mode) {
      case "hour":
        initializeDataTable(columnsHour, headerHour);
        break;
      case "day":
        initializeDataTable(columnsDay, headerDay);
        break;
      default:
        initializeDataTable(columnsMonth, headerMonth);
        break;
    }
    $("#periode").trigger("change");
  }

  function shiftPeriodeOrg064(step) {
    const mode = getPeriodeModeOrg064();
    let m = getCurrentPeriodeMomentOrg064();

    if (step > 0 && isAtCurrentBoundaryOrg064(m, mode)) {
      updatePeriodNavStateOrg064();
      return;
    }

    if (mode === "month") {
      m.add(step, "year");
    } else if (mode === "day") {
      m.add(step, "month");
    } else {
      m.add(step, "day");
    }

    $("#periode").datepicker("setDate", m.toDate());
  }

  $("#periode-prev").on("click", function () {
    shiftPeriodeOrg064(-1);
  });

  $("#periode-next").on("click", function () {
    shiftPeriodeOrg064(1);
  });

  // Inisialisasi default ke mode "hour"
  initializeDataTable(columnsHour, headerHour);
  updatePeriodNavStateOrg064();

  // Event listener untuk dropdown pilihan waktu
  $("#waktu").on("change", function () {
    let selectedValue = $(this).val();
    let today = new Date();
    let options = {
      autoclose: true,
      todayHighlight: true,
      language: "id",
    };

    // Hancurkan instance DatePicker sebelumnya agar bisa di-reinitialize
    $("#periode").datepicker("destroy");

    let columns;
    let headerHtml;
    if (selectedValue === "hour") {
      // Pilih Tanggal (default)
      options.format = "dd MM yyyy";
      options.minViewMode = 0; // Mode default: pilih hari
      options.startView = 0; // Tampilan awal: hari
      columns = columnsHour;
      headerHtml = headerHour;
    } else if (selectedValue === "day") {
      // Pilih Bulan
      options.format = "MM yyyy";
      options.minViewMode = 1; // Mode bulan
      options.startView = 1; // Tampilan awal: bulan
      columns = columnsDay;
      headerHtml = headerDay;
    } else if (selectedValue === "month") {
      // Pilih Tahun
      options.format = "yyyy";
      options.minViewMode = 2; // Mode tahun
      options.startView = 2; // Tampilan awal: tahun
      columns = columnsMonth;
      headerHtml = headerMonth;
    }

    // Re-inisialisasi DatePicker lalu muat ulang tabel & grafik
    $("#periode").datepicker(options).datepicker("setDate", today);
    syncFilterDateFromPeriode();
    reloadTelemetryForMode(selectedValue);
    updatePeriodNavStateOrg064();
  });

  syncFilterDateFromPeriode();
  updatePeriodNavStateOrg064();
  $("#periode").trigger("change");
});
